import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const textCss = css(typography.effra18, { color: colorsPalette.grey80 });

export const titleCss = css(typography.effra22, {
  color: colorsPalette.grey,
  marginBottom: 22,
});

export const containerPaddingCss = css({
  padding: '64px 0 64px',
  [MediaQueries.md]: {
    padding: '96px 0 55px',
  },
  [MediaQueries.lgAndUp]: {
    padding: '96px 0 97px',
  },
});

export const containerMarginCss = css({
  margin: '64px 0 64px',
  [MediaQueries.md]: {
    margin: '96px 0 55px',
  },
  [MediaQueries.lgAndUp]: {
    margin: '96px 0 97px',
  },
});

export const columns2Css = css({
  [MediaQueries.lgAndUp]: {
    columns: 2,
    columnGap: 32,
  },
});
